exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drawer-footer[data-v-5182566c]{margin:0;white-space:nowrap}", ""]);

// exports
